import React, { useState } from 'react'
import { ModalWrapper, SelectField } from '../../../../../../components'
import { useDispatch, useSelector } from 'react-redux'
import classes from './AddStops.module.css'
import { StaticAlt } from '../../../../../../shared/utils/constants'
import { addfile, cross, search } from '../../../../../../assets/icons'
import { useGlobal } from '../../../../../../shared'
import { baseURL, urls } from '../../../../../../shared/config'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import { setLoader, setRefreshPage, setStopID } from '../../../../../../redux/globalSlice'
import { Checkbox, FormControlLabel } from '@mui/material'

const AddStop = ({ open, setHandleOpen, handleClose, setstopDetailsOpen }) => {
  const details = useSelector((state) => state.global.SchoolDInfo)
  const [selectedStop, setSelectedStop] = useState(null)
  const { data: stopData } = useGlobal({ userUrl: `${urls.STOP_GET}${details.route_id}` })
  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${baseURL}${urls.STOP_DELETE}${selectedStop.stop_id}`)
      if (response?.data?.status === 202) {
        toast.success('Data Deleted Successfuly')
        dispatch(setLoader(false))
        handleClose()
        dispatch(setRefreshPage(true))
      }
    } catch (error) {
      console.error(error)
      toast.error('Error Submitting Data')
    }
  }
  const dispatch = useDispatch()

  console.log('---details', details)

  return (
    <>
      <ModalWrapper open={open} handleClose={handleClose} title={'Add Stops'} width={'517px'}>
        <div className={classes.container}>
          {/* <InfoField label={'hoy'} value={data?.route_number} width={'100%'} />
        <InfoField label={'Area'} value={data?.route_area} width={'100%'} /> */}
          <div className={classes.subcontainer}>
            <p className={classes.txt}>Route Information</p>
            <div className={classes.details}>
              <div className={classes.subdetail}>
                <p className={classes.headingtxt}>Van No.</p>
                <p className={classes.detailtxt}>
                  {details?.vans?.length > 0
                    ? details?.vans?.map((van) => van.van_number).join(', ')
                    : 'No van assigned'}
                </p>
              </div>
              <hr className={classes.rule} />
              <div className={classes.subdetail}>
                <p className={classes.headingtxt}>School Name</p>
                <p className={classes.detailtxt}>{details.school_name}</p>
              </div>
              <hr className={classes.rule} />
              <div className={classes.subdetail}>
                <p className={classes.headingtxt}>Route</p>
                <div className={classes.routetxt}>{details.route_name}</div>
              </div>
            </div>
          </div>
          <div
            style={{
              gap: '4px',
            }}
            className={classes.subcontainer}
          >
            <div className={classes.top}>
              <div className={classes.titlediv}>
                <p className={classes.txt}>Stops</p>
                <div className={classes.xount}>{parseInt(stopData?.length)}</div>
              </div>
              <p onClick={setHandleOpen} className={classes.addnew}>
                + Add New
              </p>
            </div>
            <div className={classes.stops}>
              {stopData?.map((value, index) => {
                return (
                  <div key={index} className={classes.stop}>
                    <p
                      onClick={() => {
                        setstopDetailsOpen()
                        dispatch(setStopID(value))
                      }}
                      className={classes.stoptxt}
                    >
                      {`${value?.stop_address},` +
                        `${value?.stop_city},` +
                        `${value?.stop_state},` +
                        value?.stop_pincode}
                    </p>
                    <img
                      src={cross}
                      alt={StaticAlt}
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setSelectedStop(value)
                        handleDelete()
                      }}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  )
}

export default AddStop

export const AddNewStop = ({ addopen, setHandleClose, setSearchOpen, setaddManualstopOpen }) => {
  const tiles = [
    {
      icon: search,
      title: 'Search Address',
      content: 'You can through the list to find a address.',
      id: 'search',
    },
    {
      icon: addfile,
      title: 'Add Manual',
      content: 'You can add address manually by fill the form',
      id: 'manual',
    },
  ]

  return (
    <ModalWrapper
      open={addopen}
      handleClose={setHandleClose}
      title={'Add New Stops'}
      width={'500px'}
    >
      <div className={classes.tiles}>
        {tiles?.map((value, index) => {
          return (
            <div
              onClick={value.id === 'search' ? setSearchOpen : setaddManualstopOpen}
              key={index}
              className={classes.tile}
            >
              <div className={classes.icon}>
                <img src={value.icon} alt={StaticAlt} />
              </div>
              <div className={classes.txtdiv}>
                <p className={classes.maintxt}>{value.title}</p>
                <p className={classes.subcontent}>{value.content}</p>
              </div>
            </div>
          )
        })}
      </div>
    </ModalWrapper>
  )
}
export const SearchStop = ({ addopen, setHandleClose }) => {
  const [search, setSearch] = React.useState('')
  const stops = [
    '2715 Ash Dr. San Jose, South Dakota 83475',
    '2715 Ash Dr. San Jose, South Dakota 83475',
    '2715 Ash Dr. San Jose, South Dakota 83475',
    '2715 Ash Dr. San Jose, South Dakota 83475',
  ]
  function truncateText(text, maxWidth, container, startChars = 10, endChars = 10) {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    ctx.font = window.getComputedStyle(container).font

    if (ctx.measureText(text).width <= maxWidth) {
      return text // No need to truncate if it fits
    }

    const start = text.slice(0, startChars)
    const end = text.slice(-endChars)
    let truncated = `${start}...${end}`

    while (ctx.measureText(truncated).width > maxWidth && startChars > 0 && endChars > 0) {
      startChars--
      endChars--
      const start = text.slice(0, startChars)
      const end = text.slice(-endChars)
      truncated = `${start}...${end}`
    }

    return truncated
  }

  return (
    <ModalWrapper
      open={addopen}
      handleClose={setHandleClose}
      title={'Search Address'}
      width={'466px'}
    >
      <div className={classes.searchcontainer}>
        <input
          onChange={(e) => {
            setSearch(e.target.value)
          }}
          value={search}
          className={classes.input}
        />
        <div className={classes.subcontainer}>
          <div className={classes.top}>
            <div className={classes.titlediv}>
              <p className={classes.txt}>Search Results</p>
              <div className={classes.xount}>4</div>
            </div>
          </div>
          <div className={classes.stops}>
            {stops?.map((value, index) => {
              const container = document.createElement('div')
              const truncatedText = truncateText(value, 307, container)
              return (
                <div key={index} className={classes.stop}>
                  <p className={classes.stoptxt}>{truncatedText}</p>
                  <input type="checkbox" className={classes.checkbox} />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}

export const ManualStop = ({ addopen, setHandleClose }) => {
  const [selectedGrade, setSelectedGrade] = useState('')
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [step, setStep] = useState(1)
  const [selectedClass, setSelectedClass] = useState('')
  const data = useSelector((state) => state.global.SchoolDInfo)

  const dispatch = useDispatch()
  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${customRole == 'Admin' ? userSchoolId : schoolName}&page=1&limit=1000`,
  })
  
  // const { data: studentList } = useGlobal({
  //   userUrl: `${urls.STUDENT_STOP_GET}${userSchoolId}&grade_id=${selectedGrade}&section_id=${selectedClass}`,
  // })

  // console.log('---studentList',studentList);

  const selectedGradeObj = grades?.find((g) => String(g.grade_id) === String(selectedGrade))

  const [formData, setFormData] = useState({
    student_id: [],
    registration_number: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    pincode: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }
  const toggleStudent = (studentId) => {
    setFormData((prev) => {
      if (prev.student_id.includes(studentId)) {
        return {
          ...prev,
          student_id: prev?.student_id?.filter((id) => id !== studentId),
        }
      } else {
        return {
          ...prev,
          student_id: [...prev.student_id, studentId],
        }
      }
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const responseBody = {
      route_id: data?.route_id,
      ...formData,
    }
    try {
      const response = await axios.post(`${baseURL}${urls.STOP_POST}`, responseBody)

      if (response?.data?.status == 201 || response?.data?.status == 200) {
        toast.success('Route Added Successfully!')
        dispatch(setLoader(false))
        setHandleClose()
        dispatch(setRefreshPage(true))
      } else {
        toast.error('Stop is Already Added For Selected Student')
      }
    } catch (error) {
      console.error(error)
      toast.error('Error Submitting Data')
      setHandleClose()
      dispatch(setLoader(false))
    }
    // Close modal after submission
  }
  const handleStep = () => {
    if (formData.student_id.length === 0) {
      toast.error('Please select at least one student')
      return
    }
    setStep(1)
  }
  const handleStepBack = () => {
    setStep(1)
  }

  return (
    <>
      {/* <ToastContainer /> */}
      <ModalWrapper open={addopen} handleClose={setHandleClose} title="Add Manually" width="466px">
        <form onSubmit={handleSubmit}>
          {/* {step === 0 && (
            <div className={classes.form}>
              <div className={classes.text_fields}>
                <SelectField
                  placeholder={''}
                  options={(grades || [])?.map((prod) => ({
                    value: prod.grade_id,
                    label: prod.grade,
                  }))}
                  onChange={(selectedOption) => setSelectedGrade(selectedOption)}
                  value={selectedGrade || ''}
                  subLabel={'Grade :'}
                  width={'auto'}
                />

     
                {selectedGrade && (
                  <SelectField
                    placeholder={''}
                    options={(selectedGradeObj?.grade_sections || [])?.map((prod) => ({
                      value: prod.section_id,
                      label: prod.section,
                    }))}
                    onChange={(selectedOption) => setSelectedClass(selectedOption)}
                    value={selectedClass || ''}
                    subLabel={'Class :'}
                    width={'auto'}
                  />
                )}
              </div>

              <label className={classes.label}>Students</label>
              <SelectField
                label="Student Name"
                options={(studentList || []).map((prod) => ({
                  value: prod.student_registration_number,
                  label: prod.student_name,
                }))}
                placeholder="Choose a Student"
                required
                width="100%"
                name="student_name"
                value={formData.registration_number}
                onChange={handleSelectChange}
              />
              {selectedGrade && selectedClass && (
                <div className={classes.boxing}>
                  {studentList?.map((student, index) => {
                    const isChecked = formData.student_id?.includes(student.student_id)
                    const isLast = index === studentList.length - 1
                    // console.log('Student:', student.student_id, student.student_name) // ← add this

                    // const isChecked = formData.student_id?.includes(student.student_id)

                    return (
                      <div
                        key={student.student_id}
                        style={{ borderBottom: isLast ? 'none' : '' }}
                        className={classes.subjrxt}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={() => toggleStudent(student.student_id)}
                            />
                          }
                          label={`${student.student_name}`}
                          labelPlacement="end"
                        />
                      </div>
                    )
                  })}
             
                </div>
              )}

              <div className={classes.wrapper}>
                <label className={classes.label}>Registration Number</label>
                <input
                  type="text"
                  name="registration_number"
                  value={formData.registration_number}
                  onChange={handleChange}
                  placeholder="Enter Registration Number"
                  className={classes.input}
                  readOnly // Since it's auto-filled
                />
              </div>

              <button type="button" onClick={handleStep} className={classes.button}>
                Next
              </button>
            </div>
          )} */}
          {step === 1 && (
            <div className={classes.form}>
              <p className={classes.titletxt}>Address Information</p>
              <div className={classes.wrapper}>
                <label className={classes.label}>Address</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className={classes.input}
                  placeholder="Enter Address"
                />
              </div>

              <div className={classes.wrapper}>
                <label className={classes.label}>Address 2</label>
                <input
                  type="text"
                  name="address2"
                  value={formData.address2}
                  onChange={handleChange}
                  className={classes.input}
                  placeholder="Enter Address 2"
                />
              </div>

              <div className={classes.wrapper}>
                <label className={classes.label}>City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className={classes.input}
                  placeholder="Enter City"
                />
              </div>

              <div className={classes.full}>
                <div className={classes.wrapper}>
                  <label className={classes.label}>State</label>
                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    className={classes.input}
                    placeholder="Enter State"
                  />
                </div>
                <div className={classes.wrapper}>
                  <label className={classes.label}>Zip Code</label>
                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    className={classes.input}
                    placeholder="Enter Zip Code"
                  />
                </div>
              </div>
              <div className={classes.buttons}>
                {/* <button onClick={handleStepBack} className={classes.backbtn} type="button">
                  Back
                </button> */}
                <button type="submit" className={classes.button}>
                  Add
                </button>
              </div>
            </div>
          )}
        </form>
      </ModalWrapper>
    </>
  )
}
